import * as $ from "jquery";
import {Helpers} from "../helpers/helpers";

/**
 * Класс по работе с куками
 */
export default class AcceptanceCookies {
    private COOKIE_NAME = 'ACCEPTANCE_COOKIES';
    private COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 1 неделя
    private SHOW_CLASS = 'open';

    private readonly $popup: JQuery;

    private selectors = {
        popupClass: '.js-acceptance-cookies',
        confirmButton: '.js-confirm-popup',
        closeButton: '.js-acceptance-cookie-close',
    }

    constructor() {
        this.confirmClickHandler =  this.confirmClickHandler.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.$popup = $(this.selectors.popupClass);

        if (this.checkCookie()) {
            return;
        }

        this.showPopup();
        this.initEvents();
    }

    /**
     * Инициализация событий
     */
    private initEvents(): void {
        this.$popup.on('click', this.selectors.confirmButton, this.confirmClickHandler);
        this.$popup.on('click', this.selectors.closeButton, this.closePopup);
    }

    /**
     * Установить куку
     * @private
     */
    private setConfirmCookie(): void
    {
        Helpers.setCookie(this.COOKIE_NAME, '1', {expires: this.COOKIE_MAX_AGE});
    }

    /**
     * Проверить наличие куки
     * @private
     */
    private checkCookie(): boolean
    {
        return !!Helpers.getCookie(this.COOKIE_NAME);
    }

    /**
     * Обработчик клика подтверждения
     * @private
     */
    private confirmClickHandler(): void
    {
        this.setConfirmCookie();
        this.closePopup();
    }

    /**
     * Показываем попап
     */
    private showPopup(): void {
        this.$popup.addClass(this.SHOW_CLASS);

    }

    /**
     * Скрываем попап
     */
    private closePopup(): void {
        this.$popup.removeClass(this.SHOW_CLASS);
    }
}
